module.exports = __webpack_public_path__ + "static/media/encounters.e5a4b9c4.png";